import { isEmpty as V } from "../../utils/isEmpty.js";
import { isObject as b } from "../../utils/isObject.js";
import { tryParseNumber as d } from "../../utils/tryParseNumber.js";
import { FORM_VALID as o } from "./Form.constant.js";
function j(r) {
  return r !== o;
}
function g(r) {
  if (!r)
    return [];
  if (typeof r == "function")
    return [r];
  if (typeof r == "object")
    return Array.isArray(r) ? r : Object.values(r);
  throw new Error(
    `Expecting a function, an object or an array, got ${r}`
  );
}
const A = /* @__PURE__ */ Symbol("requiredFields"), E = /* @__PURE__ */ Symbol("requiredValidator");
function q(r = {}, i = {}) {
  function t(e, c, y) {
    const s = g(
      r[e] ?? []
    );
    try {
      for (const u of s) {
        const m = u(c, y, i);
        if (m !== o)
          return m;
      }
      return o;
    } catch (u) {
      return String(u);
    }
  }
  const n = {};
  for (const [e, c] of Object.entries(r)) {
    const s = g(c).some((u) => u[E] === !0);
    n[e] = s;
  }
  return t[A] = n, t;
}
function S(r) {
  return r[A] || {};
}
const f = (r, i, t, ...n) => typeof r == "function" ? r(i, t, ...n) : r, l = (r) => {
  switch (typeof r) {
    case "number":
      return Number.isNaN(r);
    case "boolean":
      return !1;
    default:
      return V(r);
  }
};
function D(r) {
  const i = (t, n, e) => l(t) ? f(r, t, n, e) : o;
  return i[E] = !0, i;
}
function M(r, i) {
  return (t, n, e) => typeof t == "string" && (t === "" || t.length >= r) ? o : f(i, t, n, r, e);
}
function _(r, i) {
  return (t, n, e) => typeof t == "string" && (t === "" || t.length <= r) ? o : f(i, t, n, r, e);
}
const R = (r) => typeof r == "number" && !Number.isNaN(r);
function w(r, i) {
  return (t, n, e) => R(t) && t >= r ? o : f(i, t, n, r, e);
}
function x(r, i) {
  return (t, n, e) => R(t) && t <= r ? o : f(i, t, n, r, e);
}
function N(r) {
  return Array.isArray(r[0]);
}
function T(r, i) {
  return (t, n, e) => (Number.isNaN(t) || typeof t != "number") && typeof t != "string" ? f(i, t, n, r, e) : (N(r) ? r : [r]).some(([s, u]) => {
    const m = d(s), p = d(u), a = d(t);
    return m === null || p === null || a === null ? !1 : a >= m && a <= p;
  }) ? o : f(i, t, n, r, e);
}
function k(r, i) {
  return (t, n, e) => !r && !t || r && t === !0 ? o : f(i, t, n, e);
}
function B(r, i) {
  return (t, n, e) => typeof t == "string" && (t === "" || r.test(t)) ? o : f(i, t, n, r, e);
}
function Q(r, i) {
  return (t, n, e) => typeof t == "string" && (t === "" || !r.test(t)) ? o : f(i, t, n, r, e);
}
const F = (r, i) => {
  if (V(i))
    return r;
  const t = { ...r };
  for (const [n, e] of Object.entries(i)) {
    const c = t[n];
    Array.isArray(c) && Array.isArray(e) ? t[n] = e : b(c) && b(e) ? t[n] = F(c, e) : t[n] = e;
  }
  return t;
};
export {
  k as booleanValue,
  f as formatErrorMessage,
  S as getRequiredFieldsFromValidate,
  j as isError,
  q as makeValidate,
  B as matchingRegExp,
  x as max,
  _ as maxLength,
  F as mergeFormValues,
  w as min,
  M as minLength,
  Q as missingRegExp,
  T as range,
  D as required
};
